import * as angular from "angular";
import template from "./entity-contact-modal.html";
import "./entity-contact-modal.less";
import { ContactInfoModalController } from "../../../../../../contact-info/contact-info-modal";
import entityContact from "../entity-contact";

export default angular
	.module("vesl.components.entity-modal.tabs.components.entity-contact-modal", [entityContact])
	.component("entityContactModal", {
		controller: ContactInfoModalController,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<",
			reload: "&"
		}
	})
	.name;
